import { FormattedMessage, injectIntl, MessageDescriptor, WrappedComponentProps } from 'react-intl';

type IntlMessagesProps = Partial<MessageDescriptor> & WrappedComponentProps;

const IntlMessages = (props: IntlMessagesProps) => {
  if (!props.id) {
    return null;
  }
  return <FormattedMessage {...props} />;
};

export default injectIntl(IntlMessages);
